import React, { useState } from 'react';
import CoursesTab from '../components/courses/CoursesTab';
import CourseTopicsTab from '../components/courses/CourseTopicsTab';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { id: 'courses', label: 'COURSE', icon: '📚' },
  { id: 'topics', label: 'COURSE TOPICS', icon: '📝' },
];

function CourseManagement() {
  const [activeTab, setActiveTab] = useState('courses');
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="settings-tab-icon">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-content">
        {activeTab === 'courses' && <CoursesTab tenantId={user?.tenantId} />}
        {activeTab === 'topics' && <CourseTopicsTab tenantId={user?.tenantId} />}
      </div>
    </div>
  );
}

export default CourseManagement;
